import { type ItineraryDTO, type ItineraryLegDTO } from "../../../../types/dtos/api/itinerary/itinerary.dto";
import { type DynamicIslandItinerarySummaryPayload } from "../../dynamicIsland.types";

/**
 * Maps selected itinerary state to a itinerary summary island payload.
 *
 * @param selectedItinerary Active public-transport itinerary from Home, if any.
 * @param carItineraryData Active car-mode itinerary (`ITakeMyCarData`), if any.
 * @param selectedLeg Currently highlighted leg, if any.
 * @returns Payload when a multi-leg itinerary is selected; otherwise undefined.
 */
export function mapItineraryToDynamicIslandPayload(
    selectedItinerary: ItineraryDTO | null,
    carItineraryData: ItineraryDTO | null,
    selectedLeg: ItineraryLegDTO | null,
): DynamicIslandItinerarySummaryPayload | undefined {
    const activeItinerary = selectedItinerary ?? carItineraryData;

    if ( activeItinerary === null || activeItinerary.legs.length <= 1 ) {
        return undefined;
    }

    return {
        "kind":          "itinerarySummary",
        "itineraryId":   activeItinerary.id,
        "legs":          activeItinerary.legs,
        "selectedLegId": selectedLeg?.id ?? null,
    };
}
